
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class Installing extends Vue {
  @Prop({ default: 'Start Installing' })
  public title!: string;
}
